import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { useCheckoutConfigContext } from '@contexts/CheckoutConfig';
import { FormValues, STEP } from '@types';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { When } from 'react-if';
import Amount from './Amount';

import { withModal } from '@contexts/Modal';
import { useStepper } from '@contexts/Stepper';

const Donation: FC = () => {
  const { checkout } = useCheckoutConfigContext();
  const { t } = useTranslation();
  const {
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useFormContext<FormValues>();
  const { goToStep, isValidating, serverError } = useStepper();

  const handleNext = () => {
    // clearErrors();

    // // validate riseact privacy policy
    // if (!getValues('privacyAccepted')) {
    //   setError('privacyAccepted', t('You must agree to our terms in order to proceed'));
    //   return;
    // }

    // // validate org privacy fields
    // if (
    //   checkout.campaign.privacy_fields.some(
    //     (f) => f.is_required && !getValues('acceptedPrivacyFields').includes(f.code),
    //   )
    // ) {
    //   setError('acceptedPrivacyFields', t('You must agree to our terms in order to proceed'));
    //   return;
    // }

    goToStep(STEP.SUPPORTER);
  };

  return (
    <Flex
      direction="column"
      h="full"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          goToStep(STEP.SUPPORTER);
        }
      }}
    >
      <Box w="full" pb={8}>
        <Text fontWeight="semibold" fontSize="xl" color="blackAlpha.800" w="full">
          {t('How much you can help')}
        </Text>
        <Text fontSize="md">{t('Select the amount you want to donate')}</Text>
      </Box>

      <Amount />

      <Box flexGrow={1} minH={4} />

      <When condition={!!errors.amount?.message}>
        <Text textAlign="center" fontSize="sm" color="red.500" pb={4}>
          {errors.amount?.message}
        </Text>
      </When>

      <When condition={!!errors.frequency?.message}>
        <Text textAlign="center" fontSize="sm" color="red.500" pb={4}>
          {errors.frequency?.message}
        </Text>
      </When>

      <When condition={!!serverError}>
        <Text textAlign="center" fontSize="sm" color="red.500" pb={4}>
          {serverError}
        </Text>
      </When>

      <Button
        size="lg"
        mt={4}
        alignSelf="flex-end"
        colorScheme="primary"
        onClick={handleNext}
        isLoading={isValidating}
        disabled={isValidating}
      >
        {t('Next')}
      </Button>
    </Flex>
  );
};

export default withModal(Donation);
